import API from "./Api";

function getAllCycle() {
  return API().get("/api/review/cycle/all");
}

export { getAllCycle };
